import { template as template_fd9b2463e5f141cfb5666b64daa1f11a } from "@ember/template-compiler";
import eq from 'ember-truth-helpers/helpers/eq';
import gt from 'ember-truth-helpers/helpers/gt';
import TasksKitList, { getEntityFromGroupId, getEntityIdFromGroupId } from 'volta/components/tasks-kit/list';
import ForecastProjectPayload from 'volta/components/tasks-kit/list/forecast-project-payload';
import PoPayload from 'volta/components/tasks-kit/list/po-payload';
import SkuPayload from 'volta/components/tasks-kit/list/sku-payload';
import type { TOC } from '@ember/component/template-only';
import type { TEntityType } from 'volta/models/types/entity-types';
import type { TCommonListArgs } from '.';
export interface TasksKitListEntitySignature {
    Args: TCommonListArgs & {
        entities: Record<string, {
            linkedEntityType: TEntityType;
        }>;
        onLightBg?: boolean;
    };
    Element: HTMLDivElement;
}
const TasksKitListEntityComponent: TOC<TasksKitListEntitySignature> = template_fd9b2463e5f141cfb5666b64daa1f11a(`
  <TasksKitList
    @isLoading={{@isLoading}}
    @entityResourceName={{@entityResourceName}}
    @dueDateIdPrefix={{@dueDateIdPrefix}}
    @tasks={{@tasks}}
    @selectedTask={{@selectedTask}}
    @onSubmit={{@onSubmit}}
    @onResolve={{@onResolve}}
    @onDelete={{@onDelete}}
    @onDraft={{@onDraft}}
    @onSelect={{@onSelect}}
    @isAutoResolvable={{@isAutoResolvable}}
    @selectedView={{@selectedView}}
    @taskType={{@taskType}}
    @newDisabled={{@newDisabled}}
    @showTaskType={{true}}
    @readonlyTasks={{@readonlyTasks}}
    @hideAddButton={{@hideAddButton}}
    @authorizedUsers={{@authorizedUsers}}
    @taskWrapperClass={{@taskWrapperClass}}
    @onLightBg={{@onLightBg}}
    class='u-py-1'
    ...attributes
    as |groupId _tasks index|
  >
    {{#let
      (getEntityIdFromGroupId groupId) (getEntityFromGroupId @entities groupId)
      as |entityId entity|
    }}
      {{#if entity}}
        <div class={{if (gt index 0) 'u-border-top-divider u-pt-2'}}>
          {{#if (eq entity.linkedEntityType 'skus')}}
            {{! @glint-ignore }}
            <SkuPayload @payload={{entity}} @id={{entityId}} />
          {{else if (eq entity.linkedEntityType 'planningOrders')}}
            {{! @glint-ignore }}
            <PoPayload @payload={{entity}} @id={{entityId}} />
          {{else if (eq entity.linkedEntityType 'forecastProjects')}}
            {{! @glint-ignore }}
            <ForecastProjectPayload @payload={{entity}} @id={{entityId}} />
          {{/if}}
        </div>
      {{/if}}
    {{/let}}
  </TasksKitList>
`, {
    eval () {
        return eval(arguments[0]);
    }
});
export default TasksKitListEntityComponent;
declare module '@glint/environment-ember-loose/registry' {
    export default interface Registry {
        'TasksKit::List::Entity': typeof TasksKitListEntityComponent;
        'tasks-kit/list/entity': typeof TasksKitListEntityComponent;
    }
}
